<template>
    <div class="dokan-announcement-form-wrapper">
        <tabs/>
        <h1 class="wp-heading-inline">{{ pageTitle }}</h1>
        <a @click="$router.go(-1)" class="page-title-action">{{ __( 'Go Back', 'dokan' ) }}</a>

        <hr class="wp-header-end">

        <div id='dokan-quote-notice'>
            <div v-if="quoteNoticeClass" :class="'quote-notice ' + quoteNoticeClass">
                <span v-html="quoteNoticeText"></span>
            </div>
        </div>

        <form action="" method="post" id="post">
            <div id="poststuff">
                <div id="post-body" class="metabox-holder flex sm:flex-col md:flex-row gap-5">
                    <div class='md:w-[80%]'>
                        <div class="!mb-0 post-body-content" :class="checkRtl">
                            <div id="titlediv">
                                <div id="titlewrap">
                                    <input type="text" v-model="quote.quote_title" name="post_title" size="30" id="title" autocomplete="off" :placeholder="__('Enter quote title', 'dokan')" required="required">
                                </div>
                                <div class="inside"></div>
                            </div>

                            <div id="postdivrich" class="postarea wp-editor-expand">
                                <postbox :title="__( 'Customer Information', 'dokan' )" extraClass="request-quote-settings">
                                    <ul class="error-message" v-if="errorMessage.length > 0" v-for="error in errorMessage">
                                        <li>{{ error }}</li>
                                    </ul>
                                    <table class="form-table announcement-meta-options">
                                        <tbody>
                                        <tr>
                                            <th>{{ __('Quote user', 'dokan') }}</th>
                                            <td>
                                                <multiselect  @select="onSelectCustomer" autocomplete="off" :showNoOptions="false" v-model="quote.user_id" id="ajax" label="name" track-by="id" :placeholder="__('Type to search', 'dokan')" open-direction="bottom" :options="customers" @search-change="asyncCustomerFind" :clear-on-select="true" :close-on-select="true" :searchable="true" :hide-selected="true"></multiselect>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                {{ __('Full Name', 'dokan') }}
                                            </th>
                                            <td>
                                                <input type="text" size="50" :placeholder="__('Full Name', 'dokan')" name="name_field" v-model="quote.customer_info.name_field" required="required" style="border-left: 2px solid rgb(202, 16, 16);">
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                {{ __('Email', 'dokan') }}
                                            </th>
                                            <td>
                                                <input type="email" size="50" :placeholder="__('Email', 'dokan')" name="email_field" v-model="quote.customer_info.email_field" required="required" style="border-left: 2px solid rgb(202, 16, 16);">
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                {{ __('Company Name', 'dokan') }}
                                            </th>
                                            <td>
                                                <input type="text" size="50" :placeholder="__('Company Name', 'dokan')" name="company_field" v-model="quote.customer_info.company_field">
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                {{ __('Phone Number', 'dokan') }}
                                            </th>
                                            <td>
                                                <input type="text" size="50" :placeholder="__( 'Phone Number', 'dokan' )" name="phone_field" v-model="quote.customer_info.phone_field" @input.prevent="validatePhoneInput">
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </postbox>
                            </div>

                            <div id="postdivrich" class="postarea wp-editor-expand">
                                <postbox :title="__( 'Shipping Details', 'dokan' )" extraClass="request-quote-settings">
                                    <table class="form-table announcement-meta-options">
                                        <tbody>
                                            <tr>
                                                <th>{{ __('Country', 'dokan') }}</th>
                                                <td>
                                                    <multiselect @select="onSelectCountries" autocomplete="off" :showNoOptions="false" v-model="quote.country" id="ajax" label="name" track-by="code" :placeholder="__('Type to search', 'dokan')" open-direction="bottom" :options="countries" @search-change="asyncCountriesFind" :clear-on-select="true" :close-on-select="true" :searchable="true" :hide-selected="true"></multiselect>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{ __('State', 'dokan') }}
                                                </th>
                                                <td>
                                                    <multiselect @select="onSelectStates" autocomplete="off" :showNoOptions="false" v-model="quote.state_name" id="ajax" label="name" track-by="code" :placeholder="__('Type to search', 'dokan')" open-direction="bottom" :options="stateList" @search-change="asyncStatesFind" :clear-on-select="true" :close-on-select="true" :searchable="true" :hide-selected="true"></multiselect>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{ __('Postal Code', 'dokan') }}
                                                </th>
                                                <td>
                                                    <input type="text" size="50" :placeholder="__('ex - 12345', 'dokan')" name="post_code" v-model="quote.customer_info.post_code" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{ __('Address Line 1', 'dokan') }}
                                                </th>
                                                <td>
                                                    <input type="text" size="50" :placeholder="__('Road, Area etc.', 'dokan')" name="addr_line_1" v-model="quote.customer_info.addr_line_1" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{ __('Address Line 2', 'dokan') }}
                                                </th>
                                                <td>
                                                    <input type="text" size="50" :placeholder="__( 'Apartment, Suite etc.', 'dokan' )" name="addr_line_2" v-model="quote.customer_info.addr_line_2" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{ __('Expected Delivery', 'dokan') }}
                                                </th>
                                                <td>
                                                    <Datepicker type="text" size="50" format="yy-mm-dd" :placeholder="__( 'Select Date', 'dokan' )" name="expected_delivery_date" :startFromCurrentDate="true" v-model="quote.expected_delivery_date" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </postbox>
                            </div>
                        </div>
                        <div class="postbox-container">
                            <postbox :title="__( 'Quote Details', 'dokan' )" extraClass="request-quote-settings">
                                <div v-if="productErrorMessage.length > 0">
                                    <ul class="error-message" v-for="error in productErrorMessage">
                                        <li>{{ error }}</li>
                                    </ul>
                                </div>

                                <div id="select-vendor-store">
                                    <label for="ajax">{{ __( 'Select Vendor:', 'dokan' ) }}</label>
                                    <div class="vendor-selection-box">
                                        <multiselect
                                            id="ajax"
                                            label="name"
                                            track-by="id"
                                            :options="stores"
                                            :searchable="true"
                                            autocomplete="off"
                                            :hide-selected="true"
                                            :showNoOptions="false"
                                            v-model="quote.vendor"
                                            open-direction="bottom"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            @select="onSelectStore"
                                            @search-change="asyncStoreFind"
                                            style="width: 75%; float: left;"
                                            :placeholder="__( 'Type to search', 'dokan' )"
                                        ></multiselect>
                                        <span v-if="showProductTable" class="selection-field-layer"></span>
                                    </div>
                                </div>

                                <table v-if="showProductTable" class="form-table dokan-quote-product">
                                    <thead>
                                    <tr>
                                        <th v-for="column in columns">{{ column.label }}</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="( product, index ) in requested_table_products">
                                        <td>
                                            <img width="50" :src="product.images[0].src" class="attachment-thumbnail size-thumbnail" :alt="product.name" loading="lazy" :title="product.name">
                                        </td>
                                        <td>
                                            <div>
                                                <a :href="product.permalink" target="_blank">{{ product.name }} </a>
                                            </div>
                                            <div>
                                                {{ __('Vendor: ', 'dokan') }}
                                            </div>
                                            <div>
                                                {{ product.store.name }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ formatMoney(product.price) }}
                                        </td>
                                        <td>
                                            <span class="input-layer" style="margin-right: 30px;">
                                                <input
                                                    type="text"
                                                    :value="formatMoney(quote.offer_price[index])"
                                                    @input="updatePrice($event, index)"
                                                    name="offer_price"
                                                    id="offer_price"
                                                    style="width: 5em; min-height: 40px;"
                                                    autocomplete="off">
                                                <span v-if="isQuoteEditable" class="selection-field-layer"></span>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="input-layer" style="margin-right: 30px;">
                                                <input type="number" v-model="quote.offer_product_quantity[index]" name="offer_product_quantity" min="1" id="offer_product_quantity" style="width: 5em; min-height: 40px;" autocomplete="off">
                                                <span v-if="isQuoteEditable" class="selection-field-layer"></span>
                                            </span>
                                        </td>
                                        <td>
                                            {{ formatMoney(quote.offer_price[index] * quote.offer_product_quantity[index]) }}
                                        </td>
                                        <td v-if="QUOTE_STATUS.CONVERTED !== quote.status">
                                            <a @click="removeFromQuote(index)">
                                                <span style="color: red; cursor: pointer" class="dashicons dashicons-no"></span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <strong id="dokan-shipping-cost">{{ __( 'Shipping Cost: ', 'dokan' ) }}</strong>
                                        </td>
                                        <td colspan="2">
                                            <span class="input-layer" style="margin-right: 30px;">
                                                <input
                                                    type="text"
                                                    :value="formatMoney(quote.shipping_cost)"
                                                    @input="updatePrice($event)"
                                                    name="shipping_cost"
                                                    min="0"
                                                    id="offer_shipping_cost"
                                                    style="width: 5em; min-height: 40px;"
                                                    autocomplete="off">
                                                <span v-if="isQuoteEditable" class="selection-field-layer"></span>
                                            </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td style="text-align: right" colspan="5">
                                            {{ __('Subtotal (Standard)', 'dokan') }}
                                        </td>
                                        <td style="text-align: left" colspan="2">
                                            {{ formatMoney(total) }}
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>

                                <footer>
                                    <!--Add Product Button-->
                                    <input
                                        v-if="quote.vendor && !isQuoteEditable && quote.status !== QUOTE_STATUS.CONVERTED"
                                        type="button"
                                        class="button button-default draft-btn"
                                        @click.prevent="openModal()"
                                        :value="addProductBtnLabel"
                                        :disabled="loadSpinner"
                                    />
                                    <div class="quote-action-buttons" style="float: right; display: flex; gap: 8px;">
                                        <!-- Create Quote Button-->
                                        <input
                                            type="submit"
                                            :disabled="loadSpinner"
                                            :value="publishBtnLabel"
                                            v-if="!this.$route.params.id"
                                            class="button button-primary publish-btn"
                                            @click.prevent="createRequestAQuote(createStatus)"
                                        />
                                        <!-- Quote Re-Open Button-->
                                        <input
                                            v-if="quote.status === QUOTE_STATUS.REJECTED"
                                            type="submit"
                                            class="button button-primary publish-btn"
                                            :value="reOpenBtnLabel"
                                            @click.prevent="createRequestAQuote(createStatus)"
                                            :disabled="loadSpinner"
                                        />
                                        <!-- Reject Quote Button-->
                                        <input
                                            type="submit"
                                            :value="rejectBtnLabel"
                                            :disabled="loadSpinner"
                                            @click.prevent="rejectQuote"
                                            class="button button-default draft-btn"
                                            v-if="(quote.status !== QUOTE_STATUS.CONVERTED && quote.status !== QUOTE_STATUS.REJECTED) && quoteId !== ''"
                                        />
                                        <!--Approve Quote Button-->
                                        <input
                                            v-if="( quote.status === QUOTE_STATUS.PENDING ) && quoteId !== ''"
                                            type="button"
                                            class="button button-primary publish-btn"
                                            @click.prevent="createRequestAQuote( quoteUpdated ? QUOTE_STATUS.UPDATED : QUOTE_STATUS.APPROVED )"
                                            :value="quoteUpdated ? updateOrderBtnLabel : approveOrderBtnLabel"
                                            :disabled="loadSpinner"
                                        />
                                        <!--Convert to Order Button-->
                                        <input
                                            v-if="( quote.status === QUOTE_STATUS.APPROVED || quote.status === QUOTE_STATUS.ACCEPTED || quote.status === QUOTE_STATUS.UPDATED ) && quoteId !== ''"
                                            type="button"
                                            class="button button-primary publish-btn"
                                            @click.prevent="updateQuote( quoteId, QUOTE_STATUS.CONVERTED )"
                                            :value="addOrderBtnLabel"
                                            :disabled="loadSpinner"
                                        />
                                    </div>
                                </footer>
                            </postbox>
                        </div>
                        <div class="postbox-container" v-if="quote.customer_info.customer_additional_msg || quote.store_info.vendor_additional_msg">
                            <div id="postdivrich" class="postarea wp-editor-expand">
                                <postbox :title="__( 'Additional Message', 'dokan' )" extraClass="request-quote-msg-settings">
                                    <div class="details">
                                        <div id="customer-additional-msg" v-if="quote.customer_info.customer_additional_msg">
                                            <div class="customer-profile">
                                                <img height="42" width="42" v-if="typeof quote.customer_info.user_avatar !== 'undefined' && quote.customer_info.user_avatar" :alt="__( 'Customer Avatar', 'dokan' )" :src="quote.customer_info.user_avatar" />
                                            </div>
                                            <div class="customer-content">
                                                <div class="customer-name">
                                                    <label v-html="quote.customer_info.name_field"></label>
                                                </div>
                                                <div class="customer-msg">
                                                    <p v-html="quote.customer_info.customer_additional_msg"></p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr v-if="quote.customer_info.customer_additional_msg && quote.store_info.vendor_additional_msg" />
                                        <div id="vendor-additional-msg" v-if="quote.store_info.vendor_additional_msg">
                                            <div class="customer-profile">
                                                <img height="42" width="42" v-if="typeof quote.store_info.user_avatar !== 'undefined' && quote.store_info.user_avatar" :alt="__( 'Vendor Avatar', 'dokan' )" :src="quote.store_info.user_avatar" />
                                            </div>
                                            <div class="customer-content">
                                                <div class="customer-name">
                                                    <label v-html="quote.store_info.store_name"></label>
                                                </div>
                                                <div class="customer-msg">
                                                    <p v-html="quote.store_info.vendor_additional_msg"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </postbox>
                            </div>
                        </div>
                    </div>
                    <div class="md:!w-[20%] postbox-container">
                        <postbox :title="__( 'Publish', 'dokan' )" extraClass="announcement-actions">
                            <div v-if="quote.status !== QUOTE_STATUS.CONVERTED">
                                <div class="action">
                                    <input type="submit" class="button button-default draft-btn" :value="draftBtnLabel" @click.prevent="createRequestAQuote('draft')" :disabled="loadSpinner">
                                    <span class="spinner" v-if="loadSpinner"></span>
                                    <div class="clear"></div>
                                </div>
                            </div>
                            <h2 v-if="quote.status === QUOTE_STATUS.CONVERTED">{{ __('This quote is already converted into order.', 'dokan') }}</h2>
                            <a v-if="quote.order_url && quote.status === QUOTE_STATUS.CONVERTED" @click.prevent="redirectToOrder" target="_blank">
                                <input type="button" class="button button-primary publish-btn" @click.prevent="addProductToQuote()" :value="viewQuoteLinkBtnLabel" :disabled="loadSpinner" />
                            </a>
                        </postbox>
                    </div>
                </div>
                <br class="clear">
            </div>
        </form>
        <modal
            :footer="true"
            @close="hideModal"
            v-if="showModal && quote.vendor"
            :title="__( 'Add Product(s)', 'dokan')"
        >
            <template slot="body">
                <multiselect autocomplete="off" v-model="product_id" style="width: 75%; float: left" id="ajax" label="product_title" track-by="id" :showNoOptions="false" :placeholder="__('Type to search', 'dokan')" open-direction="bottom" :options="requested_products" @search-change="searchProducts" :clear-on-select="true" :close-on-select="true" :searchable="true" :hide-selected="true"></multiselect>
                <input type="number" v-model="product_quantity" name="quantity" size="10" min="1" id="quantity" style="width: 5em; float: right; min-height: 40px; margin-right: 30px" autocomplete="off">
            </template>
            <template slot="footer">
                <button type="button" class="button button-primary publish-btn" @click.prevent="addProductToQuote" v-html="addProductToQuoteBtnLabel" :disabled="loadSpinner"></button>
            </template>
        </modal>
    </div>
</template>

<script>
import Tabs from '../components/Tabs.vue'
const TextEditor  = dokan_get_lib('TextEditor')
const Modal       = dokan_get_lib('Modal');
const Postbox     = dokan_get_lib('Postbox')
const Multiselect = dokan_get_lib('Multiselect')
const Debounce    = dokan_get_lib('debounce');
const apiBase     = 'request-for-quote';
const Datepicker  = dokan_get_lib('Datepicker');

const swal = Swal.mixin({
    customClass: {
        confirmButton: 'button button-primary',
        cancelButton: 'button button-secondary'
    },
    buttonsStyling: false
});

const QUOTE_STATUS = {
    PENDING: 'pending',
    UPDATED: 'updated',
    REJECTED: 'reject',
    APPROVED: 'approve',
    ACCEPTED: 'accepted',
    CONVERTED: 'converted',
}

export default {
    name: 'NewRequestQuote',

    components: {
        Tabs,
        Postbox,
        TextEditor,
        Modal,
        Multiselect,
        Debounce,
        Datepicker,
    },

    data () {
        return {
            QUOTE_STATUS,
            quoteId: '',
            loading: false,
            showModal: false,
            createStatus: QUOTE_STATUS.PENDING,
            showProductTable: false,
            requested_table_products: [],
            responcedProduct: [],
            requested_products: [],
            customers: [],
            countries: [],
            stateList: [],
            stores: [],
            pageTitle: this.__('Add New Quote', 'dokan'),
            display_converter: false,
            quote: {
                vendor: '',
                country: '',
                state_name: '',
                quote_title: '',
                status: QUOTE_STATUS.PENDING,
                customer_info: {
                    name_field: '',
                    email_field: '',
                    company_field: '',
                    phone_field: '',
                    country: '',
                    city: '',
                    post_code: '',
                    addr_line_1: '',
                    addr_line_2: '',
                    state_address: '',
                    customer_additional_msg: '',
                    user_avatar: '',
                },
                store_info: {
                    store_id: '',
                    store_name: '',
                    user_avatar: '',
                    vendor_additional_msg: '',
                },
                user_id: '',
                product_ids: [],
                offer_price: [],
                offer_product_quantity: [],
                expiry_days: 0,
                enable_expiry_date: false,
                formatted_expiry_date: '',
                converted_by: '',
                shipping_cost: 0,
                expected_delivery_date: '',
                order_url: '',
            },
            product_quantity: 1,
            product_id: '',
            columns: {
                'thumbnail' : { label: this.__( 'Thumbnail', 'dokan' ) },
                'item' : { label: this.__( 'Item', 'dokan' ) },
                'cost' : { label: this.__( 'Cost', 'dokan' ) },
                'off_price' : { label: this.__( 'Off. Price', 'dokan' ) },
                'qty' : { label: this.__( 'Qty', 'dokan' ) },
                'off_subtotal' : { label: this.__( 'Off. Subtotal', 'dokan' ) },
            },
            loadSpinner: false,
            errorMessage: [],
            productErrorMessage: [],
            isLoading: false,
            quoteUpdated: false,
            initialTotal: 0,
            draftBtnLabel: this.__('Save as Draft', 'dokan'),
            reOpenBtnLabel: this.__('Re-Open', 'dokan'),
            rejectBtnLabel: this.__('Reject', 'dokan'),
            publishBtnLabel: this.__('Create', 'dokan'),
            addStoresBtnLabel: this.__('Add store', 'dokan'),
            viewQuoteLinkBtnLabel: this.__('View Order', 'dokan'),
            addProductBtnLabel: this.__('Add product(s)', 'dokan'),
            updateOrderBtnLabel: this.__('Update Quote', 'dokan'),
            approveOrderBtnLabel: this.__('Approve Quote', 'dokan'),
            addOrderBtnLabel: this.__('Convert to Order', 'dokan'),
            addProductToQuoteBtnLabel: this.__('Add to quote', 'dokan'),
        }
    },

    computed: {
        total: function (){
            return this.updatedTotal();
        },
        submitBtnLabel () {
            return this.statusesLabel[this.quote.status]
        },
        checkRtl () {
            return isRtl === 1 && isRtl !== undefined ? 'lang_rtl' : ''
        },
        checkLangRtlHelp () {
            return isRtl === 1 && isRtl !== undefined ? 'help-block-rtl' : 'help-block-ltr'
        },
        quoteNoticeClass() {
            switch ( this.quote.status ) {
                case 'cancel':
                    return 'cancel-notice';
                case 'accepted':
                    return 'accepted-notice';
                case 'updated':
                    return 'update-notice';
                case 'reject':
                    return 'rejected-notice';
                case 'pending':
                    return this.quote.enable_expiry_date && this.quote.expiry_days > 0 ? 'pending-notice' : '';
                case 'approve':
                    return this.quote.expiry_days > 0 ? 'approved-notice' : '';
                case 'expired':
                    return this.quote.expiry_days > 0 ? 'expired-notice' : '';
                case 'converted':
                    return this.quote.converted_by ? 'converted-notice' : '';
                default:
                    return '';
            }
        },
        quoteNoticeText() {
            const { status, expiry_days, formatted_expiry_date, converted_by } = this.quote;

            switch ( status ) {
                case 'cancel':
                    return this.__( 'The Quote is Cancelled by the Customer.', 'dokan' );
                case 'accepted':
                    return expiry_days > 0 ? this.sprintf(
                        this.__( 'The Quote is Accepted by the Customer. Please convert it before the quote expires on %s.', 'dokan' ),
                        `<strong>${formatted_expiry_date}</strong>`
                    ) : this.__( 'The Quote is Accepted by the Customer', 'dokan' );
                case 'updated':
                    return this.__( 'The Quote has been Updated by the vendor. See below.', 'dokan' );
                case 'reject':
                    return this.__( 'The Vendor has Rejected the Quotation. Send a New Quote.', 'dokan' );
                case 'pending':
                    return expiry_days > 0 ? this.sprintf(
                        this.__( 'Please be Aware that the Quote Will Expire After %s from the Approval.', 'dokan' ),
                        `<strong>${expiry_days === 1 ? `${expiry_days} day` : `${expiry_days} days`}</strong>`
                    ) : '';
                case 'approve':
                    return expiry_days > 0 ? this.sprintf(
                        this.__( 'The quote will expire on %s.', 'dokan' ),
                        `<strong>${formatted_expiry_date}</strong>`
                    ) : '';
                case 'expired':
                    return expiry_days > 0 ? this.sprintf(
                        this.__( 'The quote expired after %s.', 'dokan' ),
                        `<strong>${formatted_expiry_date}</strong>`
                    ) : '';
                case 'converted':
                    return converted_by ? this.sprintf(
                        this.__( 'The Quote Has been Converted to an Order%s.', 'dokan' ),
                        this.display_converter ? this.sprintf( this.__( ' By %s', 'dokan' ), converted_by ) : ''
                    ) : '';
                default:
                    return '';
            }
        },
        isQuoteEditable() {
            const editableStatusList = [ QUOTE_STATUS.ACCEPTED, QUOTE_STATUS.UPDATED, QUOTE_STATUS.APPROVED ];
            return editableStatusList.includes( this.quote.status );
        }
    },

    watch: {
        total(newVal, oldVal) {
            // Check if the initial total has been set.
            if ( newVal !== this.initialTotal && this.$route.params.id && this.quote.status === 'pending' ) {
                this.quoteUpdated = true;
            } else {
                this.quoteUpdated = false;
            }
        },
    },

    methods: {
        formatMoney(value){
            return accounting.formatMoney(value, dokan.currency);
        },
        updatePrice: Debounce( function( event, index = 0 ) {
            const { id, value: rawValue } = event.target;

            // Normalize value using the proper decimal separator
            const value = accounting.unformat( rawValue, dokan.currency.decimal );

            // Accept numbers, empty strings, or a single dot (in-progress input)
            const isValid = !isNaN( parseFloat( value ) ) || rawValue === '' || rawValue === '.';

            if ( !isValid ) return;

            switch ( id ) {
                case 'offer_price':
                    this.$set( this.quote.offer_price, index, value );
                    break;

                case 'offer_shipping_cost':
                    this.quote.shipping_cost = value;
                    break;
            }
        }, 500 ),
        hideModal() {
            this.showModal = false;
        },
        openModal() {
            this.product_id = '';
            this.product_quantity = 1;
            this.showModal = true;
        },
        searchProducts: Debounce( function( search = '' ) {
            let self = this;
            if ( search.length < 1 ) {
                return;
            }
            this.isLoading = true

            // fetch products
            dokan.api.get( '/products', {
                search: search,
                request_a_quote: 1,
            })
            .done( ( response ) => {
                self.responcedProduct   = response;
                const filtered_products = response.filter( (item) => parseInt( item.store.id ) === parseInt( self.quote.vendor.id ) );
                self.requested_products = filtered_products.map( function (item) {
                    return {
                        product_id: item.id,
                        product_title: item.name,
                    }
                });
            })
            .always( () => {
                self.isLoading = false
            })
            .fail( (response) => {
                self.requested_products = [ { product_id: 0, product_title: self.__( 'No product found', 'dokan' ) } ];
                let message = dokan_handle_ajax_error( response );
                if ( message ) {
                    self.showAlert( message, '', 'error' );
                }
            });
        }, 300 ),
        addProductToQuote(){
            if ( !this.product_id ) {
                return;
            }

            let product_id = this.product_id.product_id;
            let product_quantity = this.product_quantity;
            let products = [...this.requested_table_products];
            let product_ids = [...this.quote.product_ids];
            let offer_price = [...this.quote.offer_price];
            let offer_product_quantity = [...this.quote.offer_product_quantity];
            _.map(this.responcedProduct, function (item, index) {
                if (item.id === product_id && item.price >= 1 && product_quantity >= 1){
                    product_ids.push(item.id);
                    offer_price.push(item.price);
                    offer_product_quantity.push(product_quantity);
                    return products.push(item);
                }
            })

            this.requested_table_products = products;
            this.quote.product_ids = product_ids;
            this.quote.offer_price = offer_price;
            this.quote.offer_product_quantity = offer_product_quantity;

            this.showProductTable = true;
            this.hideModal();
        },
        removeFromQuote(index){
            this.requested_table_products.splice(index, 1);
            this.quote.product_ids.splice(index, 1);
            this.quote.offer_price.splice(index, 1);
            this.quote.offer_product_quantity.splice(index, 1);

            if (this.requested_table_products.length <= 0){
                this.showProductTable = false;
                this.quote.offer_price = [];
                this.quote.offer_product_quantity = [];
            }
        },
        asyncCustomerFind: Debounce( function( query = '' ) {
            this.isLoading = true
            if ( query.length < 1 ) {
                return;
            }
            dokan.api.get('/request-for-quote/customers', { search: query }).done(response => {
                this.isLoading = false;
                this.customers = _.map(response, function (item) {
                    return {
                        id       : item.id,
                        name     : item.username + '( ' + item.email + ' )',
                        email    : item.email,
                        username : item.username,
                        billing  : item.billing,
                    }
                });
            });
        }, 300 ),
        asyncCountriesFind: Debounce( function() {
            this.isLoading = true;
            this.countries = this.getCountries();
            this.isLoading = false;
        }, 300 ),
        asyncStatesFind: Debounce( function() {
            if ( this.quote.country.code === 'undefined' || ! this.quote.country.code  ) {
                return;
            }

            this.isLoading = true;
            this.stateList = this.getStates();
            this.isLoading = false;
        }, 300 ),
        asyncStoreFind: Debounce( function( query = '' ) {
            this.isLoading = true
            if ( query.length < 1 ) {
                return;
            }
            dokan.api.get('/stores', { search: query }).done(response => {
                this.isLoading = false;
                this.requested_products = [];
                let store_info = this.quote.store_info;
                this.stores = _.map(response, function (item) {
                    store_info = {
                        store_id   : item.id,
                        store_name : item.store_name,
                    };
                    return {
                        id   : item.id,
                        name : item.store_name,
                    };
                });
                this.quote.store_info = store_info;
            });
        }, 300 ),
        onSelectCustomer( customer ) {
            this.quote.customer_info = {
                ...this.quote.customer_info,
                'customer_id'   : customer?.id,
                'email_field'   : customer?.email,
                'name_field'    : customer?.username,
                'phone_field'   : customer?.billing?.phone,
                'country'       : customer?.billing?.country,
                'city'          : customer?.billing?.city,
                'post_code'     : customer?.billing?.postcode,
                'addr_line_1'   : customer?.billing?.address_1,
                'addr_line_2'   : customer?.billing?.address_2,
                'state_address' : customer?.billing?.state,
            };

            this.countries = [
                {
                    code: customer?.billing?.country,
                    name: dokan.countries?.[ customer?.billing?.country ],
                }
            ];
            this.quote.country = this.countries;
            this.stateList = [
                {
                    code: customer?.billing?.state,
                    name: dokan.states?.[ customer?.billing?.country ]?.[ customer?.billing?.state ],
                }
            ];
            this.quote.state_name = this.stateList;
        },
        onSelectStore() {
            this.quote.product_ids = [];
            this.requested_products = [];
        },
        onSelectCountries( country ) {
            this.quote.customer_info = {
                ...this.quote.customer_info,
                'country' : country?.code,
            };

            this.stateList = [];
            this.quote.state_name = '';
            this.quote.customer_info.state_address = '';
        },
        onSelectStates( state ) {
            this.quote.customer_info = {
                ...this.quote.customer_info,
                'state_address' : state?.code,
            };
        },
        getCountries() {
            const allCountries = [];
            // Set all the countries as key value pair.
            Object.entries( dokan.countries ).forEach( ( [ code, country ] ) => allCountries.push({ code, name: country }) );

            return allCountries;
        },
        getStates() {
            const allStates = [];
            // Set all the countries as key value pair.
            Object.entries( dokan.states?.[ this.quote.country.code ] ).forEach( ( [ code, state ] ) => allStates.push({ code, name: state }) );

            return allStates;
        },
        filterUndefined(data){
            return data.filter( (element) => element !== undefined );
        },
        clearAll () {
            this.quote.user_id = '';
        },

        createRequestAQuote (status) {
            if (this.$route.params.id) {
                this.updateRequestAQuote(status);
            }else {
                this.saveQuoteRequest(status);
            }
        },

        saveQuoteRequest (status) {
            this.loadSpinner = true
            let jsonData = jQuery.extend({}, this.quote)
            jsonData.offer_price = this.filterUndefined([...jsonData.offer_price]);
            jsonData.offer_product_quantity = this.filterUndefined([...jsonData.offer_product_quantity]);
            jsonData.user_id = this.quote.user_id.id;

            jsonData.status = status;
            if ( !this.validateFormFields(jsonData) ) {
                this.loadSpinner = false
                return false;
            }

            jsonData.shipping_cost = parseFloat( jsonData.shipping_cost );
            dokan.api.post('/' + apiBase, jsonData )
                .done( response => {
                    this.loadSpinner = false;
                    this.sendToPages();
                })
                .error( response => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });
        },
        updateRequestAQuote (status) {
            let id = this.$route.params.id;
            this.loadSpinner = true
            let jsonData = jQuery.extend({}, this.quote)
            jsonData.product_ids = this.filterUndefined([...jsonData.product_ids]);
            jsonData.offer_price = this.filterUndefined([...jsonData.offer_price]);
            jsonData.offer_product_quantity = this.filterUndefined([...jsonData.offer_product_quantity]);
            if (Array.isArray(this.quote.user_id)){
                jsonData.user_id = this.quote.user_id[0].id;
            }else {
                jsonData.user_id = this.quote.user_id.id;
            }

            jsonData.status = status;
            jsonData.id = id;

            if ( !this.validateFormFields(jsonData) ) {
                this.loadSpinner = false
                return false;
            }

            dokan.api.put('/' + apiBase +'/' + id, jsonData )
                .done( response => {
                    this.loadSpinner = false;
                    this.sendToPages();
                })
                .error( response => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });
        },
        rejectQuote() {
            swal.fire( {
                icon: 'warning',
                text: this.__( 'Are you sure want to Reject the deal?', 'dokan' ),
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: this.__( 'OK', 'dokan' ),
                cancelButtonText: this.__( 'Cancel', 'dokan' )
            } )
                .then( ( result ) => {
                    if ( result.isConfirmed ) {
                        this.createRequestAQuote('reject');
                    }
                } );
        },
        redirectToOrder() {
            window.open( this.quote.order_url, '_blank' ); // Redirect to the quote order URL.
        },
        validateFormFields(quoteData){
            let isValid = true;
            this.errorMessage = [];
            this.productErrorMessage = [];
            if ( quoteData.quote_title === '' ) {
                this.errorMessage.push( this.__('Quote Title is required.', 'dokan') );
                isValid = false;
            }

            if ( quoteData.user_id === '' || quoteData.user_id === undefined ) {
                this.errorMessage.push( this.__('Customer is required.', 'dokan') );
                isValid = false;
            }

            if (quoteData.vendor === '') {
                this.productErrorMessage.push(this.__('Store selection is required. Please select at least one store.', 'dokan'));
                isValid= false;
            } else {
                if (quoteData.product_ids.length <= 0) {
                    this.productErrorMessage.push(this.__('Please select at least one product.', 'dokan'));
                    isValid= false;
                } else {
                    for (let i = 0; i < quoteData.product_ids.length; i++) {
                        if(quoteData.product_ids[i] === '' || quoteData.product_ids[i] === undefined){
                            this.productErrorMessage.push(this.__('Please select at least one product.', 'dokan'));
                            isValid= false;
                        }
                    }
                }

                if (quoteData.offer_price.length <= 0) {
                    this.productErrorMessage.push(this.__('Please select at least one price.', 'dokan'));
                    isValid= false;
                } else {
                    for (let i = 0; i < quoteData.offer_price.length; i++) {
                        if(quoteData.offer_price[i] === '' || quoteData.offer_price[i] == 0){
                            this.productErrorMessage.push(this.__('Offer price can\'t be zero.' , 'dokan'));
                            isValid= false;
                        }
                    }
                }

                if (quoteData.offer_product_quantity.length <= 0) {
                    this.productErrorMessage.push(this.__('Please add at least one offer product quantity.', 'dokan'));
                    isValid= false;
                } else{
                    for (let i = 0; i < quoteData.offer_product_quantity.length; i++) {
                        if(quoteData.offer_product_quantity[i] === '' || quoteData.offer_product_quantity[i] == 0){
                            this.productErrorMessage.push(this.__('Offer product quantity can\'t be zero.' , 'dokan'));
                            isValid= false;
                        }
                    }
                }
            }

            return isValid;
        },
        validatePhoneInput( event ) {
            this.quote.customer_info.phone_field = this.quote.customer_info.phone_field.replace( /[^0-9\\.\-\_\(\)\+]+/g, '' );
        },
        sendToPages(){
            this.$router.push({
                name: 'RequestAQuote',
            });
        },
        updatedTotal() {
            let total = 0;
            this.quote.offer_price.forEach((price, i) => {
                if (0 < price) {
                    total += parseFloat(price) * parseFloat(this.quote.offer_product_quantity[i]);
                }
            });

            total += parseFloat(this.quote.shipping_cost);
            return total;
        },
        fetchAQuote(id){
            this.loading = true;

            dokan.api.get('/' + apiBase + '/' + id).done((response) => {
                this.quote.quote_title = response.title;
                this.quote.vendor = {
                    id   : response?.store_info?.store_id,
                    name : response?.store_info?.store_name,
                };
                this.quote.status = response.status;
                this.quote.converted_by = response.converted_by;
                this.quote.shipping_cost = response.shipping_cost;
                this.display_converter = response.show_converter;
                this.quote.store_info = response?.store_info;
                if (0 != response.customer_info) {
                    this.quote.customer_info = response.customer_info ? response.customer_info : {};
                    this.customers = [
                        {
                            id: response.customer.user_id,
                            name: response.customer.user_login + '( ' + response.customer.user_email + ' )',
                        }];
                    this.quote.user_id = this.customers;
                    this.countries = [
                        {
                            code: response.customer_info.country,
                            name: dokan.countries?.[ response.customer_info.country ],
                        }
                    ];
                    this.quote.country = this.countries;
                    this.stateList = [
                        {
                            code: response.customer_info.state_address,
                            name: dokan.states?.[ response.customer_info.country ]?.[ response.customer_info.state_address ],
                        }
                    ];
                    this.quote.state_name = this.stateList;
                    this.quote.customer_info.user_avatar = response?.customer?.user_avatar;
                }
                this.requested_table_products = response.products;

                if ( response.enable_expiry_date ) {
                    this.quote.expiry_days           = response?.expiry_days;
                    this.quote.enable_expiry_date    = response?.enable_expiry_date;
                    this.quote.formatted_expiry_date = response?.expiry_formatted_date;
                }

                if ( typeof response.order_url !== 'undefined' && response.order_url ) {
                    this.quote.order_url = response.order_url;
                }

                if ( typeof response.expected_date !== 'undefined' && response.expected_date ) {
                    this.quote.expected_delivery_date = response.expected_date;
                }

                let product_ids = [];
                let offer_price = [];
                let offer_product_quantity = [];
                _.map(response.products, function (value, index) {
                    product_ids.push(value.id);
                    offer_price[index] = value.offer_price;
                    offer_product_quantity[index] = value.offer_product_quantity;
                });

                this.pageTitle = this.__('Edit Quote', 'dokan');
                this.quote.product_ids = product_ids;
                this.quote.offer_price = offer_price;
                this.quote.offer_product_quantity = offer_product_quantity;
                this.initialTotal = this.updatedTotal();
                this.loading = false;
                this.showProductTable = true;
            });
        },

        /**
         * Update's status for quotes from admin dashboard action
         *
         * @since 3.7.30
         *
         * @param quoteId
         * @param status
         *
         * @return void
         */
        updateQuote( quoteId, status ) {
            dokan.api.post( '/' + apiBase + '/convert-to-order', {
                quote_id: quoteId,
                status: status,
            } ).done( response => {
                this.loadSpinner = false;
                this.sendToPages();
            } ).fail( error => {
                this.loadSpinner = false;
                alert( error.responseJSON.message );
            } )

        },

        showAlert( $title, $des, $status ) {
            swal.fire( $title, $des, $status );
        },
    },

    created () {
        if (this.$route.params.id) {
            this.quoteId = this.$route.params.id;
            this.fetchAQuote(this.$route.params.id);
        }
    },
}
</script>

<style lang="less">

.dokan-announcement-form-wrapper {
    position: relative;

    .help-block {
        position: absolute;
        top: 10px;

        span.help-text {
            display: inline-block;
            margin-top: 4px;
            margin-right: 6px;

            a {
                text-decoration: none;
            }
        }

        span.dashicons {
            font-size: 25px;
        }
    }
    .error-message {
        background-color: #f2dede;
        color: #ff0000;
        padding: 10px;
    }

    .help-block-rtl {
        left: 10px;
    }

    .help-block-ltr {
        right: 10px;
    }

    #post-body {
        .post-body-content {
            position: relative;
            width: 100%;
            min-width: 463px;
            float: left;
            margin-bottom: 20px;

            #postdivrich {
                margin-top: 20px;
            }
        }

        .announcement-actions {
            background: #fafafa;

            .action {
                padding: 15px 0px;

                .spinner {
                    visibility: visible;
                    float: none;
                }

                .draft-btn {
                    float: left;
                }

                .publish-btn {
                    float: right;
                }
            }

            .sub-action {
                #jj, #aa, #hh, #mm {
                    padding: 1px;
                    font-size: 12px;
                }

                #jj, #hh, #mm {
                    width: 2em;
                }

                #timestamp {
                    .dashicons {
                        &:before {
                            color: #82878c;
                            position: relative;
                            top: -1px;
                        }
                    }
                }
            }
        }

        .inside {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;

            .main {
                row-gap: 12px;
                display: grid;
            }
        }
    }

    #select-vendor-store {
        gap: 50px;
        display: flex;
        margin-top: 10px;
        align-items: center;

        .vendor-selection-box {
            width: 100%;
            position: relative;

            .selection-field-layer {
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0.5;
                background: #ddd;
                max-width: 450px;
                border-radius: 3px;
                position: absolute;
            }
        }

        label {
            width: 190px;
            font-size: 14px;
            font-weight: 600;
            text-align: left;
            line-height: 1.3;
            padding: 20px 10px 20px 0;
        }

        .multiselect {
            max-width: 450px;

            input#ajax {
                background: none !important;
                box-shadow: none !important;
                outline: 0 !important;
                border: none !important;
            }
        }
    }

    #postdivrich {
        .announcement-meta-options {
            .multiselect {
                max-width: 450px;
            }
        }

        .request-quote-msg-settings {
            .inside {
                padding: 20px;
                padding-top: 12px;
            }

            hr {
                margin: 12px 0;
                background: #E9E9E9;
            }

            #vendor-additional-msg,
            #customer-additional-msg {
                gap: 15px;
                display: flex;

                img {
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                }

                .customer-name {
                    label {
                        color: #25252D;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }

                .customer-msg {
                    p {
                        margin: 0;
                        color: #6C6C72;
                        font-size: 14px;
                    }
                }
            }
        }
    }

    #poststuff {
        .form-table {
            td {
                padding-left: 0;

                .input-layer {
                    display: inline-block;
                    position: relative;

                    .selection-field-layer {
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0.5;
                        background: #ddd;
                        max-width: 450px;
                        border-radius: 3px;
                        position: absolute;
                    }
                }
            }

            #dokan-shipping-cost {
                float: right;
                margin-right: 30px;
            }
        }
    }

    .dokan-modal {
        .modal-body {
            overflow-y: visible;
        }

        footer {
            z-index: 0;
        }
    }

    #dokan-quote-notice {
        margin-top: 10px;

        .quote-notice {
            color: #393939;
            padding: 10px 20px;
            border-radius: 3px;
            margin-bottom: 10px;
            border-left: 3px solid;

            &.accepted-notice {
                border-color: #1B6384;
                background-color: #C0E1F8;
            }

            &.update-notice {
                border-color: #7c2d12;
                background-color: #fed7aa;
            }

            &.cancel-notice,
            &.expired-notice,
            &.rejected-notice {
                border-color: #E64B5F;
                background-color: #FFE5E5;
            }

            &.pending-notice {
                border-color: var(--dokan-button-background-color, #7047EB);
                background-color: #F4F1FE;
            }

            &.approved-notice {
                border-color: #EFBB40;
                background-color: #FFF8E6;
            }

            &.converted-notice {
                border-color: #00BC8B;
                background-color: #E3FFF1;
            }
        }
    }
}

.dokan-quote-wrapper {
    .multiselect {
        min-width: 200px;

        .multiselect__select {
            height: 30px;
        }

        .multiselect__tags {
            min-height: 32px;
            max-height: 32px;
            padding-top: 4px;
        }

        input#ajax {
            border: 0 !important;

            &:focus {
                box-shadow: none;
                min-height: 24px;
                max-height: 24px;
            }
        }
    }
}

.lang_rtl {
    float: right !important;
}
</style>
